import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Event, EventService, EventPackage, EventRequestAllocation, EventRequestAllocationFacility } from '../../../../services/event.service';
import { EventRequestModalComponent, ModalMode } from '../event-request-modal/event-request-modal.component';

@Component({
  selector: 'app-event-table-detail',
  templateUrl: './event-table-detail.component.html',
  styleUrls: ['./event-table-detail.component.scss']
})
export class EventTableDetailComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectedEvent: Event;
  @Input() selectedEventPackage: EventPackage;

  isEditable: boolean;

  allocations: EventRequestAllocation[];

  selectedAllocation: EventRequestAllocation;
  requestAllocationFacilities: EventRequestAllocationFacility[];

  unsubscribe: Subject<any> = new Subject();

  @ViewChild('eventRequestModal', { static: false }) eventRequestModal: EventRequestModalComponent;

  constructor(
    private eventService: EventService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.isEditable = this.selectedEvent != null && this.selectedEvent.eventEndDate == null;
    if (!!this.selectedEventPackage) {
      this.eventService.getEventPackageDetails(this.selectedEventPackage.eventId, this.selectedEventPackage.eventRequestPackageId);
      this.eventService.eventRequestAllocations
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(eventRequestAllocations => {
          if (eventRequestAllocations) {
            this.allocations = eventRequestAllocations;
          }
        });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  viewRequestAllocation(allocation: EventRequestAllocation) {
    this.eventRequestModal.open(ModalMode.ViewOnly, this.selectedEventPackage, allocation, this.selectedEvent)
      .then(() => {
        console.info('Event Request/Allocation View Closed!');
      })
      .catch((error) => {
        console.warn(`EventRequestModal dismissed: ${error}`)
      });
  }

  newRequest() {
    this.eventRequestModal.open(ModalMode.Request, this.selectedEventPackage, {} as EventRequestAllocation, this.selectedEvent)
      .then(() => {
        console.info('Event Request Created!');
      })
      .catch((error) => {
        console.warn(`EventRequestModal dismissed: ${error}`)
      });
  }

  newAllocation() {
    var request = this.allocations[this.allocations.length - 1];
    this.eventRequestModal.open(ModalMode.Allocate, this.selectedEventPackage, request, this.selectedEvent)
      .then(() => {
        console.info('Event Allocation Created!');
      })
      .catch((error) => {
        console.warn(`EventRequestModal dismissed: ${error}`)
      });
  }

}
